import React from 'react';
import { Typography } from '@progress/kendo-react-common';
import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';

export const CannotOpenFile: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <div>
      <Typography.h2>{translate('custom.settings.adminCenter.helpCenter.cannotOpenFileTitle')}</Typography.h2>
      <Typography.p>{translate('custom.settings.adminCenter.helpCenter.cannotOpenFileMessage')}</Typography.p>
    </div>
  );
};
